<template>
    <div class="flex items-start m-3" style="width: 250px; min-width: 250px; overflow: visible;">
        <div class="mr-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="19px" height="19px" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                 class="text-theme vue-feather feather feather-check-square">
                <polyline points="9 11 12 14 22 4"></polyline>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
            </svg>
        </div>
        <div><b class="block overflow-hidden text-ellipsis text-sm font-bold">
            Selected Multiple Items
        </b> <small class="block text-xs font-bold text-gray-400">
            {{ selected.length }} Items
        </small></div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        selected: Array,
    },
    data() {
        return {}
    },
    computed: {},
    methods: {},
    mounted() {
    }
}
</script>

